import $ from "jquery";
/* eslint-disable
    class-methods-use-this,
    consistent-return,
    default-case,
    func-names,
    no-multi-assign,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import BasePage from "pages/base_page";

let TopicPage;

export default TopicPage = (function () {
  TopicPage = class TopicPage extends BasePage {
    static initClass() {
      this.prototype.events = {
        "click #tabbed-navigation a": "_clickHandheldTab",
        "click .expert-authors .more a": "_showMoreExperts",
      };
    }

    initialize(options) {
      super.initialize(options);
    }

    _clickHandheldTab(event) {
      event.preventDefault();
      const section = $(event.target).attr("href");
      $("#tabbed-navigation a.active").removeClass("active");
      $(event.target).addClass("active");
      switch (section) {
        case "#articles":
          $(".topic-page").removeClass("sm-display-contributors sm-display-links");
          return $(".topic-page").addClass("sm-display-articles");
        case "#contributors":
          $(".topic-page").removeClass("sm-display-articles sm-display-links");
          return $(".topic-page").addClass("sm-display-contributors");
        case "#links":
          $(".topic-page").removeClass("sm-display-articles sm-display-contributors");
          return $(".topic-page").addClass("sm-display-links");
      }
    }

    _showMoreExperts(event) {
      event.preventDefault();
      return $(".expert-authors").addClass("show-all");
    }
  };
  TopicPage.initClass();
  return TopicPage;
}());
